import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} cannot be later than Today.`
}

function validate(value, args) {
  if (value) {
    if (isAfter(removeTime(value), removeTime(new Date()))) return false
    else return true
  } else return true
}

export default {
  getMessage,
  validate
}
